/**
 * Licensed Materials - Property of IBM
 *
 * IBM Cognos Products: BI Glass
 *
 * (C) Copyright IBM Corp. 2017, 2021
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define({
		"rtl": "Oikealta vasemmalle",
		"timeZoneID": "Aikavyöhyke",
		"skin": "Tyyli",
		"metricsFileImportTask": "Uusi tuonti tiedostoista",
		"displayMode": "Oletusnäkymä",
		"credentialRenewed": "Valtuustietosi on uusittu nykyisellä käyttäjätunnuksella ja salasanalla.",
		"productLocale": "Tuotteen kieli",
		"toggleDisabled": "poissa",
		"credentialChange": "Uudista",
		"log_level_Debug": "Vianmääritys",
		"confirmNewPassword": "Vahvista uusi salasana",
		"unsavedViewMsg2": "Muutokset häviävät, jos et tallenna niitä ensin.",
		"supportPortalErrorMessage": "Yritä uudelleen.  Jos ongelma ei poistu, ota yhteys pääkäyttäjään.",
		"legalText": "Lisensoitua aineistoa – IBM:n omaisuutta © Copyright IBM Corporation ja muut 2005, 2020, %{year}. IBM, IBM-logo, ibm.com ja Cognos ovat International Business Machines Corporationin tavaramerkkejä tai rekisteröityjä tavaramerkkejä, jotka on rekisteröity monilla hallintoalueilla maailmassa. Ajantasainen luettelo IBM:n tavaramerkeistä on Internet-osoitteessa www.ibm.com/legal/copytrade.shtml. Tämä ohjelma on lisensoitu sen mukana toimitettavan lisenssisopimuksen ehtojen mukaisesti. Tämä lisenssisopimus toimitetaan joko ohjelman hakemistossa tai kirjastossa olevassa alihakemistossa License tai Non_IBM_License tai painettuna versiona. Lue sopimus huolellisesti ennen ohjelman käyttöä. Ohjelman käyttö on osoitus sopimuksen ehtojen hyväksymisestä.",
		"groupsAndRoles": "Ryhmät ja roolit",
		"metricsMaintenanceTask": "Uusi ylläpitotoimi",
		"email": "Sähköposti",
		"contextual": "Kontekstinmukainen",
		"resetHome": "Palauta oletusarvoon",
		"ltr": "Vasemmalta oikealle",
		"credentials": "Valtuustiedot",
		"logging_congfig_title": "Kirjaus lokiin",
		"changePasswordTitle": "Salasanan vaihto",
		"format": "Raportin muoto",
		"showUnread": "Näytä lukemattomat",
		"AILearning_active": "Tekoälyoppiminen on käytössä:",
		"docsErrorMessage": "Yritä uudelleen.  Jos ongelma ei poistu, ota yhteys pääkäyttäjään.",
		"toggleEnabled": "käytössä",
		"homeSetError": "Määritettäessä oletusaloitussivua on ilmennyt virhe. Sulje ja avaa näkymä uudelleen.",
		"passwordChange": "Vaihda salasana",
		"profile": "Profiili",
		"pdfRestricted": "PDF (rajoitettu)",
		"drillThrough": "Porautumismääritykset",
		"homeSet": "Kotisivu on määritetty",
		"regionalOptions": "Alueasetukset",
		"myPreferences": "Omat asetukset",
		"defaultHome": "Oletus",
		"version": "Versio",
		"controller": "Controller",
		"manage": "Hallitse",
		"biDirectionalFeaturesEnabled": "Kaksisuuntainen kielituki",
		"newFeaturesErrorTitle": "Uusiin ominaisuuksiin viittaava linkki ei toimi",
		"passwordMatch": "Salasanat täsmäävät",
		"updateProfileAndsettings": "Päivitä profiili ja asetukset",
		"dashboardConsole": "Työtila",
		"legacyAppsSlideoutLabel": "Käytettävissä olevat vanhat sovellukset",
		"logging_config_description": "Kirjausta käytetään vianmääritykseen. Pyydä neuvoja asetuksiin pääkäyttäjältä.",
		"confirmDeletion": "Poiston vahvistus",
		"signInButtonText": "Kirjaudu sisään",
		"dataSourceCredentials": "Tietopalvelimen valtuustiedot",
		"AILearningConfigurationSlideoutAllyLabel": "Tekoälyoppimisen kokoonpanon määritys",
		"loadingSettings": "Latausasetukset",
		"spreadsheetMLRestricted": "Excel (rajoitettu)",
		"manageAILearning": "Tekoälyoppiminen",
		"xlsxDataRestricted": "Excel-tiedot (rajoitettu)",
		"advanced": "Lisäasetukset",
		"ok": "OK",
		"changeEmail": "Muuta",
		"showHints": "Näytä vihjeet",
		"general": "Yleiset",
		"xlsxData": "Excel-tiedot",
		"newPassword": "Uusi salasana",
		"hideAll": "Piilota kaikki",
		"confirmPassword": "Vahvista salasana",
		"AILearning_config_description": "Paranna tuotteen sisäisiä suosituksia sallimalla Cognos Analyticsin oppia käyttötavoistasi.",
		"metricStudio": "Studio",
		"supportPortalErrorTitle": "Tukiportaaliin viittaava linkki ei toimi",
		"log_level_Warn": "Varoitus",
		"contentSettings": "Sisältöasetukset",
		"setHomeButton": "Joukko",
		"myCapabilities": "Omat valtuudet",
		"homePage": "Kotisivu",
		"helpErrorMessage": "Yritä uudelleen.  Jos ongelma ei poistu, ota yhteys pääkäyttäjään.",
		"loadingProfile": "Latausprofiili",
		"portal": "Portaali",
		"metricsPackage": "Uusi paketti",
		"myCredentials": "Omat valtuustiedot",
		"credentialCreate": "Luo",
		"eventStudio": "Event Studio",
		"updatePWUnknownError": "Salasanan päivitys ei onnistu",
		"showHiddenObjects": "Näytä piilotetut merkinnät",
		"csv": "CSV",
		"docsErrorTitle": "Käyttöohjeisiin viittaava linkki ei toimi",
		"log_level_Error": "Virhe",
		"wrongPassword": "Todennus ei onnistu",
		"productName": "IBM Cognos Analytics %{version}",
		"log_level_Info": "Tiedot",
		"welcomeBanner": "Tervetuloa-palkki",
		"helpErrorTitle": "Ohjeeseen viittaava linkki ei toimi",
		"contentLocale": "Sisällön kieli",
		"pdf": "PDF",
		"oldPassword": "Vanha salasana",
		"spreadsheetML": "Excel",
		"accessibilityFeatures": "Helppokäyttötoiminnot",
		"manageLogging": "Kirjaus lokiin",
		"loggingConfigurationSlideoutA11yLabel": "Kirjauksen kokoonpano",
		"communityErrorTitle": "Yhteisöön viittaava linkki ei toimi",
		"companionApps": "Oheissovellukset",
		"setHomeLabel": "Aseta kotisivuksi (nykyinen näkymä)",
		"metricsExportTask": "Uusi vienti",
		"csvRestricted": "CSV (rajoitettu)",
		"newFeaturesErrorMessage": "Yritä uudelleen.  Jos ongelma ei poistu, ota yhteys pääkäyttäjään.",
		"contributor": "Contributor",
		"showAll": "Näytä kaikki",
		"logging_active": "Kirjaus on käytössä:",
		"html": "HTML",
		"profileAndSettings": "Profiili ja asetukset",
		"baseTextDirection": "Tekstin perussuunta",
		"queryStudio": "Query Studio",
		"metricsManager": "Metrics Manager",
		"password": "Salasana",
		"invalidEmail": "Anna kelvollinen sähköpostiosoite",
		"credentialCreateSuccess": "Olet luonut valtuustiedot",
		"settings": "Asetukset",
		"restrictedFormatSelected": "Sinulla ei ole valtuuksia ajaa raportteja tässä muodossa, mutta voit käyttää raportteja, jotka on tallennettu tässä muodossa.",
		"usageDataDeletionConfirmation": "Käyttötietojen poisto nollaa kaiken tekoälyoppimisen.  Haluatko varmasti poistaa käyttötiedot?",
		"powerplayStudio": "PowerPlay Studio",
		"viewDetails": "Näytä tiedot",
		"deleteUsageData": "Poista käyttötiedot:",
		"showPassword": "Näytä salasana",
		"AILearning_config_title": "Tekoälyoppiminen",
		"myPreferencesSlideoutLabel": "Profiili ja asetukset",
		"passWordChangeSuccess": "Olet vaihtanut salasanan",
		"logging_level": "Kirjaustaso:",
		"analysisStudio": "Analysis Studio",
		"communityErrorMessage": "Yritä uudelleen.  Jos ongelma ei poistu, ota yhteys pääkäyttäjään.",
		"cancel": "Peruuta",
		"shareSetError": "Toimintoa ei voi toteuttaa ennen näkymän sulkemista ja uudelleenavaamista.",
		"passwordNotMatch": "Salasanat eivät täsmää",
		"xml": "XML",
		"xmlRestricted": "XML (rajoitettu)",
		"openMenu": "Avaa valikko",
		"closeMenu": 'Sulje valikko'
});